export default {
    error: [],
    data: null,
    show: true
}